import { makeVar } from '@apollo/client';

const emptyArray = [];
export const parametersHealthChecks = makeVar(emptyArray);

const variables = {
  parametersHealthChecks
};
export default variables;
